import { CommonButton } from '@Components/common/Button';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 43px;
`;

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  padding: 58px 52px;
  ${mq(1200)} {
    padding: 20px;
  }
`;

export const Title = styled.h6`
  padding: 18px 52px 18px 52px;
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  background-color: ${({ theme }) => theme.colors.innerProduct.gray};
  ${mq(576)} {
    padding: 16px 20px;
  }
`;

export const Button = styled(CommonButton)`
  width: 190px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  border-radius: 4px;
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
  border: none;
  background-color: ${({ theme }) => theme.colors.brandColor};
  margin-left: auto;
`;

export const FormError = styled.p`
  text-align: center;
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.brandColor};
`;
